import { Text } from '@wartek-id/text-v1'

import { PENGEMBANGAN_KOMPETENSI_ACTIVITY_LOCATION } from 'app/KinerjaPenilikPegawaiPage/constants/pengembanganKompetensi'

import type { PelaksanaanPengembanganKompetensi } from 'types/kinerja-penilik-pegawai'

type PropsListKegiatan = {
  pengembanganKompetensiKegiatanValues: PelaksanaanPengembanganKompetensi['pengembanganKompetensiKegiatanValues']
  limit?: number
}

const ListKegiatan = ({
  pengembanganKompetensiKegiatanValues,
  limit,
}: PropsListKegiatan) => {
  const shownKegiatan = pengembanganKompetensiKegiatanValues.slice(0, limit)

  return (
    <div className="flex flex-col gap-8">
      {shownKegiatan.map(
        ({ kategori, kegiatan, tempatMeningkatkanIndikator }, i) => (
          <div key={`list-kegiatan-${i}`}>
            <Text variant="subheading" className="uppercase">
              Kegiatan {i + 1}
            </Text>
            <ul className="pl-6 mt-3 break-words list-disc list-outside">
              <li className="list-item">
                <Text as="span" color="subdued">
                  Untuk meningkatkan Indikator, Anda membutuhkan:{' '}
                  {kategori.nama}
                </Text>
              </li>
              <li className="list-item">
                <Text as="span" color="subdued">
                  Dengan cara: {kegiatan.jenisKegiatan}
                </Text>
              </li>
              <li className="list-item">
                <Text as="span" color="subdued">
                  Lokasi kegiatan:{' '}
                  {
                    PENGEMBANGAN_KOMPETENSI_ACTIVITY_LOCATION[
                      tempatMeningkatkanIndikator
                    ]
                  }
                </Text>
              </li>
            </ul>
          </div>
        )
      )}
    </div>
  )
}

export default ListKegiatan
